module.exports = __webpack_public_path__ + "img/pro.2d783d5c.png";